import { withObjectionFaqs } from "@/lib/faqs";
import { createFileRoute } from "@tanstack/react-router";
import { ServicePageLayout } from "@/components/ServicePageLayout";
import { SERVICE_PAGES } from "@/lib/service-content";
import { buildService, buildFaqPage, buildBreadcrumbs, buildLocalBusiness } from "@/components/SchemaJsonLd";

const data = SERVICE_PAGES["concrete-resurfacing"];

export const Route = createFileRoute("/services/concrete-resurfacing")({
  head: () => ({
    meta: [
      { title: "Concrete Resurfacing in Calgary — Spalling, Crack & Salt Damage Repair | MLC Epoxy Floors" },
      { name: "description", content: "Concrete resurfacing in Calgary and surrounding areas. We repair spalling, cracking, salt damage, and pop-outs — then seal slabs with polyaspartic so the damage doesn't come back." },
      { property: "og:title", content: "Concrete Resurfacing in Calgary | MLC Epoxy Floors" },
      { property: "og:description", content: "Restore spalled, cracked, salt-damaged concrete in a single day. Diamond grind, structural repair, polyaspartic-sealed finish across the Calgary region." },
      { property: "og:url", content: "/services/concrete-resurfacing" },
    ],
    links: [{ rel: "canonical", href: "/services/concrete-resurfacing" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(buildLocalBusiness()) },
      { type: "application/ld+json", children: JSON.stringify(buildService(data.name, data.slug, data.intro)) },
      { type: "application/ld+json", children: JSON.stringify(buildFaqPage(withObjectionFaqs(data.faqs))) },
      { type: "application/ld+json", children: JSON.stringify(buildBreadcrumbs([
        { name: "Home", href: "/" }, { name: "Services", href: "/services" }, { name: data.name, href: `/services/${data.slug}` }
      ])) },
    ],
  }),
  component: () => <ServicePageLayout {...data} />,
});
